export class CreateFolderModel {
	Name: string;
	ParentId?:number;
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/CreateFolderModel.ts